import { render, staticRenderFns } from "./moreWM.vue?vue&type=template&id=5b2ba66d&lang=pug&"
import script from "./moreWM.vue?vue&type=script&lang=js&"
export * from "./moreWM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports